<template>
    <div class="guideContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 扫码 -->
        <div class="guideBox">
            <el-image :src="require('@/assets/image/settle.png')" fit="cover" class="guideBg" v-if="$route.query.type == '1'"></el-image>
            <el-image :src="require('@/assets/image/distribution.png')" fit="cover" class="guideBg" v-if="$route.query.type == '2'"></el-image>
            <el-image :src="require('@/assets/image/fission.png')" fit="cover" class="guideBg" v-if="$route.query.type == '4'"></el-image>
            <el-image v-if="guideCode != ''" :src="guideCode" fit="cover" class="guideCode"></el-image>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                guideCode: ''
            }
        },
        mounted(){
            this.getGuide()
        },
        methods: {
           // 获取二维码
           getGuide(){
                this.request.get("index/gongneng/detail",{
                    params:{
                       type: this.$route.query.type
                    }
                })
                .then(res=>{
                    this.guideCode = res.data
                })
            }, 
        }
    }
</script>
<style lang="less" scoped>
    .guideContent{
        width: 100vw;
        background: #FAFBFC;
        padding-bottom: 80px;
        .guideBox{
            width: 1014px;
            padding: 24px 107px;
            position: relative;
            background: #fff;
            border-radius: 10px;
            margin: 0 auto;
            .guideBg{
                width: 1014px;
                height: 534px;
            }
            .guideCode{
                width: 112px;
                height: 112px;
                position: absolute;
                top: 383px;
                left: 173px;
            }
        }
    }
</style>